import axios from 'axios';

export const apiUrl = `https://portalbeta.tracker.com/api`;

export const configureInterceptor = (
    callbackLogout: () => void,
    addActiveRequest: (id: string) => void,
    removeActiveRequest: (id: string | number | boolean) => void,
) => {
    axios.interceptors.request.use(
        (config) => {
            addActiveRequest(config.url);
            return config;
        },
        (error) => {
            return Promise.reject(error);
        },
    );
    axios.interceptors.response.use(
        function (response) {
            const url = response.config.url;

            removeActiveRequest(url);
            if (response.status === 401) {
                callbackLogout();
            }
            return response;
        },
        function (error) {
            const { response } = error;
            const url = response.config.url;

            removeActiveRequest(url);
            if (response.status === 401) {
                callbackLogout();
            }
            return Promise.reject(error);
        },
    );
};
